import React from 'react';
import { filter, map } from 'lodash';
import { INDICATION_TYPES, addIndication } from 'modules/taboola-common-frontend-modules/Indications';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { bulkOperationsApi } from 'services/api';
import { errorMessagesUtils } from 'services/utils';
import { requestSaveCampaign, saveCampaignSuccess, saveCampaignError } from '../actions';
import { fromGWtransformers, toGWtransformers } from './flowsUtils';

const successIndication = {
    message: <FormattedMessage id="campaign.save.success" defaultMessage="Campaign successfully updated" />,
    type: INDICATION_TYPES.SUCCESS,
    highlight: <FormattedMessage id="success.highlight" defaultMessage="Success!" />,
};

const generateErrorIndication = (errorObject = {}) => ({
    message: errorMessagesUtils.getErrorMessage(errorObject),
    type: INDICATION_TYPES.ERROR,
    highlight: <FormattedMessage id="campaign.save.error.highlight" defaultMessage="Unable to save changes." />,
});

export const saveBulkCampaigns =
    ({ entityType, changes, onError, onSuccess }) =>
    async dispatch => {
        const { createBulkCampaigns } = bulkOperationsApi;
        const transformedData = changes.map(campaign => ({
            value: toGWtransformers[entityType](campaign),
        }));

        dispatch(requestSaveCampaign());
        try {
            const response = await createBulkCampaigns({
                requestBody: { elements: transformedData },
                entityType,
            });
            const responseCampaigns = map(filter(response.elements, ['error', null]), ({ value }) =>
                fromGWtransformers[entityType](value)
            );

            dispatch(saveCampaignSuccess(responseCampaigns));
            dispatch(addIndication(successIndication));

            if (onSuccess) {
                onSuccess();
            }

            return response;
        } catch (error) {
            dispatch(addIndication(generateErrorIndication(error)));
            dispatch(saveCampaignError(map(changes, ({ id }) => ({ id, error }))));

            if (onError) {
                onError(error);
            }

            throw error;
        }
    };
